<template>
  <div>
    <footer class="footer" style="height: 60px; padding: 0 1rem;" v-if="lumbredocs_v3">
      <div class="d-flex justify-content-between align-items-center h-100">
        <img :src="$store.state.settings.logoLumbreDocs" style="height: 40px" height="40px" alt="Logo" class="py-2" v-if="!isOnMesaContext">
        <p class="mb-0 pr-5 d-none d-md-block">
          {{ (new Date()).getFullYear() }} © <a href="https://www.lumile.com.ar/" >Lumile</a> {{lumbreVersion}}
        </p>
      </div>
    </footer>
    <footer class="footer" v-else>
      <div class="container-fluid">
        <div class="row">
          <p class="col-12 mb-0">
            {{ (new Date()).getFullYear() }} © <a href="https://www.lumile.com.ar/" >Lumile</a> {{lumbreVersion}}
          </p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { version } from '../../package.json'
import { mapState } from 'vuex'

export default {
  inject: ['lumbredocs_v3'],
  computed: {
    ...mapState('session', ['bVersion']),
    lumbreVersion () {
      let version
      if (this.bVersion) {
        version = `(${this.appVersion} - Engine: ${this.bVersion})`
      } else {
        version = `(v${this.appVersion})`
      }
      return version
    }
  },
  data () {
    return {
      appVersion: version,
      isOnMesaContext: process.env?.VUE_APP_LUMBREDOCS_V3_MESA === 'yes'
    }
  }
}
</script>

<style lang="sass" scoped>
  .footer
    border-top: 1px solid rgba(152,166,173,.2)
    padding: 19px 30px 20px
    color: $mutedFontThemeColor
    background: #fafbfe
</style>
